var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.9881,
    cy: 8,
    rx: 7.9881,
    ry: 8,
    fill: "#B70000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80387 7.13557L8.81798 6.14822C8.7185 6.04858 8.78896 5.87822 8.92965 5.87822L9.83382 5.87822C9.96617 5.87822 10.0735 5.98567 10.0735 6.11822L10.0735 7.02373C10.0735 7.16464 9.90335 7.2352 9.80387 7.13557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31092 6.64189L6.00659 9.95115M8.81798 6.14822L9.80387 7.13557C9.90335 7.2352 10.0735 7.16464 10.0735 7.02373L10.0735 6.11822C10.0735 5.98567 9.96617 5.87822 9.83382 5.87822L8.92965 5.87822C8.78896 5.87822 8.7185 6.04858 8.81798 6.14822Z",
    stroke: "white",
    strokeWidth: 0.675663,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/Out.7c3e4de95c05be2c56e983b09724cba8.svg";
export { ForwardRef as ReactComponent };